<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <rect fill="none" height="3" rx="1.5" ry="1.5" stroke-linecap="round" stroke-linejoin="round" width="3" x="1.5" y="2.5" />
    <path d="M3.5,14.5h-2v-3H.5v-3a1,1,0,0,1,1-1h1" fill="none" stroke-linecap="round" stroke-linejoin="round" />
    <rect fill="none" height="3" rx="1.5" ry="1.5" stroke-linecap="round" stroke-linejoin="round" transform="translate(26 8) rotate(-180)" width="3" x="11.5" y="2.5" />
    <path d="M12.5,14.5h2v-3h1v-3a1,1,0,0,0-1-1h-1" fill="none" stroke-linecap="round" stroke-linejoin="round" />
    <rect fill="none" height="4" rx="2" ry="2" stroke-linecap="round" stroke-linejoin="round" width="4" x="6" y="0.5" />
    <path d="M10.5,15.5h-5v-4h-1v-3a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2v3h-1Z" fill="none" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
